import React from 'react';
import {IRenderMenuItemOptions} from "../../../menu-items-common/renderer/menu-item.renderer.interface";
import {UserMenuItemComponent} from "../../../../components/user-menu/user-menu-items/user-menu-item.component";
import {MenuItemRendererBase} from "../../../menu-items-common/renderer/menu-item-renderer-base";

export class GenericUserUserMenuItemRenderer extends MenuItemRendererBase {
    protected _createReactElement(options?: IRenderMenuItemOptions): React.ReactElement {
        return (<UserMenuItemComponent key={this.key} menuItem={this}/>);
    }
}